import React, { useCallback } from 'react';

import { Flex, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

import { TableAction } from 'components';
import useTableStore from 'stores/useTable';

const TableFooter = ({ onClick = () => null, isFetching }) => {
  const { content } = useParams<GeneralRoute>();
  const table = useTableStore(useCallback((state) => state.tables[content], [content]));

  if (!table) {
    return null;
  }

  return (
    <Flex
      px={4}
      py={3}
      borderBottomRadius={10}
      bg="gray.100"
      w="100%"
      flex={1}
      alignItems="center"
      justifyContent="space-between">
      <Flex>
        <Text
          mr={2}
          color="gray.600"
          variant="xSmallBold">{table.meta.total}
        </Text>
        <Text
          color="gray.500"
          variant="xSmallSemiBold">Itens Cadastrados
        </Text>
      </Flex>
      <Flex hidden={table.meta.total <= table.data.length}>
        <TableAction
          isLoading={isFetching}
          text="Carregar mais"
          icon="arrow-down"
          onClick={onClick}
        />
      </Flex>
    </Flex>
  );
};

export default TableFooter;
